import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams } from "react-router";
import { ArrowLeft } from "lucide-react";

import { useCenter } from "../../../center";
import { PractitionerReportView } from "../../../reports";
import CenterAdminShell from "../components/CenterAdminShell";

const KINDS = ["patient", "couple", "group"];

/**
 * One patient or student across the centre's professionals: every session
 * the centre held with them, by whom, and its statement.
 */
export default function CenterStudentReportPage() {
    const { t } = useTranslation();
    const { kind = "", subjectId = "" } = useParams();
    const { state } = useLocation() as { state: { label?: string } | null };
    const { center, loading } = useCenter();

    if (loading || !center) {
        return <p className="p-6 text-sm text-content-secondary">{t("common.loading")}</p>;
    }
    if (!KINDS.includes(kind)) {
        return <p className="p-6 text-sm text-content-secondary">{t("reports.error")}</p>;
    }

    const name = state?.label ?? t("reports.students.someone");
    return (
        <CenterAdminShell center={center} title={t("reports.students.reportTitle", { name })}>
            <PractitionerReportView
                scope={{ kind: "centre", centerId: center.id }}
                fixedSubject={`${kind}:${subjectId}`}
                title={t("reports.students.reportTitle", { name })}
                subtitle={t("reports.students.reportSubtitle")}
                headerAction={
                    <Link
                        to="/center/reports?section=students"
                        className="mb-2 inline-flex items-center gap-1.5 text-sm text-content-secondary hover:text-content-primary"
                    >
                        <ArrowLeft size={16} aria-hidden="true" />
                        {t("reports.backToCenter")}
                    </Link>
                }
            />
        </CenterAdminShell>
    );
}
